export enum POINTS_DEPART {
  POST_COLLEGE = 'Post-collège',
  POST_BAC = 'Post-bac',
  PREPA_TOUR_FRANCE_NIV_3 = 'Prépa-Tour de France - Niv 3 acquis',
  PREPA_TOUR_FRANCE_NIV_4 = 'Prépa-Tour de France - Niv 4 acquis',
  PREPA_TOUR_FRANCE_NIV_5 = 'Prépa-Tour de France - Niv 5 acquis',
}
